export default __webpack_public_path__ + "static/patient-guide--breast-cancer-da5925effbb8f124fa9021d89d336d22.jpg";